import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoggerService } from '../logging';
import { ServerVarsService } from '../server-vars/server-vars.service';
import { CurrentLocationService } from '../service/current-location.service';
import { PlatformService } from './platform.service';

@Injectable()
export class ServerSideRelativeUrlHttpInterceptor implements HttpInterceptor {
    private dockerHost: string;

    constructor(
        private platform: PlatformService,
        private serverVars: ServerVarsService,
        private logger: LoggerService,
        private currentLocation: CurrentLocationService
    ) {
        this.dockerHost =
            this.serverVars.get('DOCKER_LOCAL_WEBSERVER_HOST') ||
            `${this.currentLocation.url.protocol}//${this.currentLocation.url.hostname}${
                this.currentLocation.url.port ? ':' + this.currentLocation.url.port : ''
            }`;
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Don't need to care about absolute urls
        if (req.url.startsWith('http')) {
            return next.handle(req);
        }

        if (this.platform.isServer && req.url.startsWith('./')) {
            const newUrl = `${this.dockerHost}/${req.url.replace('./', '')}`;

            this.logger.debug(`[SSR] Rewrote local url to: ${newUrl}`);

            return next.handle(
                req.clone({
                    url: newUrl
                })
            );
        }

        return next.handle(req);
    }
}
